import { Link, useLocation } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      item: item.href ? `https://pkgogo.cn${item.href}` : `https://pkgogo.cn${location.pathname}`,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
      <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-500 py-3">
        <ol className="flex items-center flex-wrap gap-1">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <span className="mx-2 text-foreground-300" aria-hidden="true">/</span>
              )}
              {item.href && index < items.length - 1 ? (
                <Link to={item.href} className="hover:text-primary-500 transition-colors whitespace-nowrap">
                  {item.label}
                </Link>
              ) : (
                <span className={index === items.length - 1 ? "text-foreground-800 font-medium" : "text-foreground-500"}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}